import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { emailValidationSchema } from "src/helpers/yup_schema";
import { AuthenticationWrawper } from "src/components/AuthenticationWrawper";
import { TextField } from "@mui/material";
import { sendEmailOtp } from "src/thunks/auth";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import toastMessages from "src/constant/toastMessages.json";
import { GetError } from "src/constant";

const Login = () => {
  /** redux store useDispatch & useSelector ------------------------------ **/
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { sendEmailOtpLoading } = useSelector((state) => state.auth);

  /** react hook form declaration ------------------------------ **/
  const {
    register: emailRegister,
    handleSubmit: handleEmailSubmit,
    watch: emailFormWatch,
    formState: { errors: errorsEmail },
    reset: resetEmailForm,
  } = useForm({ resolver: yupResolver(emailValidationSchema) });

  /** Variable declaration ------------------------------ **/
  const emailFieldValue = emailFormWatch("email", "");
  const emailFormButtonClassName = emailFieldValue == "" ? "email-form-disabled-button" : "email-form-enabled-button";

  /** hooks useEffect----------------------------------------------------- **/

  /** To reset the email field ------------------------- **/
  useEffect(() => {
    resetEmailForm({ email: localStorage.getItem("email") });
  }, []);

  /** handler functions--------------------------------------------------- **/

  /** Function to send an OTP via email ------------------------ **/
  const onEmailSubmitHandler = async (data) => {
    try {
      let res = await dispatch(sendEmailOtp({ email: data.email })).unwrap();
      if (res) {
        toast.success(toastMessages.otpSend);
        navigate("/otp");
      }
    } catch (error) {
      toast.error(GetError(error?.response?.data?.errors) || "something issue");
    }
  };

  return (
    <AuthenticationWrawper>
      <>
        <div className="confirm-email-text-style">
          Confirm your registered email id to receive OTP
        </div>
        <div style={{ marginTop: 45, width: "85%" }}>
          <form
            className="login-form-main-class"
            onSubmit={handleEmailSubmit(onEmailSubmitHandler)}
          >
            <div className="confirm-email-formfield">
              <TextField
                className="depot-form-textfields-style"
                {...emailRegister("email")}
                id="standard-basic"
                label="Email"
                variant="standard"
              />
              <div
                className="form-errors d-flex justify-content-start mt-2 email-not-registered-error"
                style={{
                  height: 23,
                }}
              >
                {errorsEmail.email?.message && (
                  <i className="bi bi-exclamation-circle-fill me-1"></i>
                )}
                <p> {errorsEmail.email?.message}</p>
              </div>
            </div>
            <div
              className="d-flex flex-row justify-content-between "
              style={{ height: 70, paddingTop: 25, marginBottom: 0 }}
            >
              <div
                className="d-flex flex-column"
                style={{ position: "absolute", left: -8 }}
                onClick={() => navigate("/login")}
              >
                <button
                  className="d-flex justify-content-center align-items-center next-button-style create-back-button-style"
                  type="submit"
                >
                  <i
                    className="bi bi-arrow-left"
                    style={{ fontSize: 16, marginRight: 5 }}
                  ></i>
                  BACK
                </button>
                <div className="d-flex justify-content-start">
                  <i className="bi bi-caret-right-fill fold-back-button-styling"></i>
                </div>
              </div>
              <div
                className="d-flex flex-column"
                style={{ position: "absolute", right: 0 }}
              >
                <button
                  disabled={
                    emailFieldValue == "" || sendEmailOtpLoading == true
                      ? true
                      : false
                  }
                  className={`${emailFormButtonClassName} d-flex justify-content-center align-items-center next-button-style`}
                  type="submit"
                >
                  CONFIRM
                  <i
                    className="bi bi-check-lg arrow-size-for-login"
                    style={{ fontSize: 18, paddingLeft: 10 }}
                  ></i>
                </button>
                <div className="d-flex justify-content-end">
                  <i className="bi bi-caret-right-fill fold-button-styling"></i>
                </div>
              </div>
            </div>
            <div></div>
          </form>
        </div>
      </>
    </AuthenticationWrawper>
  );
};

export default Login;
